var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"expanded":_vm.tableMixin_expandedRows,"headers":_vm.tableMixin_displayedHeaders,"footer-props":{
    'items-per-page-options': [50, 100, 250, 500],
  },"items":_vm.rows,"mobile-breakpoint":0,"loading":_vm.loading,"disable-sort":""},on:{"click:row":_vm.tableMixin_onRowClick},scopedSlots:_vm._u([{key:"item.actions",fn:function(ref){
  var item = ref.item;
return [_c('BaseActionMenu',{attrs:{"actions":_vm.actions,"item":item}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }